import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { BORDER_RADIUS } from "../../utils/constants";

// eslint-disable-next-line
export const commonPropsTableCell = {
  showTooltip: true,
};

// eslint-disable-next-line
export const commonPropsTableCellHeader = {
  ...commonPropsTableCell,
  showTooltip: false,
  isHeader: true,
  isResizable: true,
};

// eslint-disable-next-line
export const commonPropsTableCellBody = {
  ...commonPropsTableCell,
  isHeader: false,
  showLastRowBorder: true,
};

export const SkeletonCampaignMetric = () => (
  <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
    <Skeleton
      variant="rounded"
      width={50}
      height={20}
      sx={{ borderRadius: BORDER_RADIUS }}
    />
  </Box>
);
